// pages/ActiveUsers.jsx
import React from 'react';
import UserListBase from './UserListBase';

const ActiveUsers = () => (
    <UserListBase statusFilter="active" title="Active Users" subtitle="Users/devices currently active" />
);

export default ActiveUsers;